module.exports = __webpack_public_path__ + "img/stop_btn.f4eb6bb3.png";